// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found_wrapper__fyV3X","link":"not-found_link__MaMZ+"};